class ValidationError extends Error {
  data: { [field: string]: Array<string> };

  constructor(data: { [field: string]: Array<string> }) {
    super(`Invalid parameters: ${Object.keys(data).join(', ')}`);

    this.name = 'ValidationError';
    this.data = data;
  }
}

export default ValidationError;
